import axios from 'axios';

const validateEmail = (email) => {
  if (email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/)) {
    return true;
  }
  return false;
}

const capitalizeFirstCharacter = (word) => {
  if (word.length < 2) {
    return word;
  }
  let first = word[0];
  let others = word.slice(1);
  return first.toUpperCase() + others;
}

async function callApi(api, method, data) {
  try {
    return await axios({
      url: api,
      method: method,
      data: data,
    });
  } catch (err) {
    return {err};
  }
}

const getStateKeyFromState = (states, state) => {
  return Object.keys(states).findIndex((val) => {
    return val === state;
  })
}

const getStateFromStateKey = (states, stateKey) => {
  return Object.keys(states)[stateKey];
}

const getCurrentDate = _ => {
  const now = new Date();
  return formatDate(now);
}

function formatDate(date) {
  var monthNames = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
  ];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();

  return `${day} ${monthNames[monthIndex]} ${year}`;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0
}

const getChangeValues = changePercentage => {
  let change = parseInt(changePercentage);
  let up = true;
  let changeStyle = {color: '#00ff00'};
  if (!isNaN(change)) {
    if (change < 0) {
      changeStyle = {color: '#ff0000'};
      up = false;
    }
    if (change === 0) {
      changeStyle = {color: '#a9a9a9'};
    }
  } else {
    change = 0;
  }
  return {
    change,
    changeStyle,
    up
  }
};

const capitalizeFirstLetter = text => {
  let char = text.split('');
  return char[0].toUpperCase()+char.slice(1).join('');
};

const formatText = ({text, num}) => {
  if (text.length > num) {
    return text.substring(0, num) + '...';
  }
  return text;
};

export {
  validateEmail,
  capitalizeFirstCharacter,
  callApi,
  getStateKeyFromState,
  getStateFromStateKey,
  getCurrentDate,
  isEmptyObject,
  getChangeValues,
  capitalizeFirstLetter,
  formatText
};